import {
  RESET_HEADER,
  SET_HEADER,
} from "./MainTypes";

export const setHeader = (headerConfigs: any) => ({
  type: SET_HEADER,
  payload: headerConfigs,
});

export const resetHeader = () => ({
  type: RESET_HEADER,
});